export enum CoordinationParametersGridType {
    frequencyPool = 'frequencyPool',
    includeFrequenciesForValidation = 'includeFrequenciesForValidation',
    friendlySelection = 'friendlySelection',
}
